import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  dashboardSuccess,
  dashboardFailure,
  saveNotesSuccess,
  saveNotesFailure,
  fetchNotesSuccess,
  fetchNotesFailure,
} from './dashboard-actions';

export function* fetchDashboard(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `dashboard/${action.payload.type}/${action.payload.id}`,
      options: {
        errorMessage: `Could not get dashboard data for ${action.payload.type}: ${
          action.payload.id
        }`,
        retryAction: action,
      },
    });
    yield put(dashboardSuccess(results));
  } catch (err) {
    yield put(dashboardFailure(err));
  }
}

export function* saveNotes(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `info/update/${action.payload.type}/${action.payload.id}/notes`,

      options: {
        method: 'PUT',
        body: JSON.stringify(action.payload.notes),
        errorMessage: `Could not save notes for ${action.payload.type}: ${action.payload.id}`,
        retryAction: action,
      },
    });
    yield put(saveNotesSuccess(results));
  } catch (err) {
    yield put(saveNotesFailure(err));
  }
}

export function* fetchNotes(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `info/${action.payload.type}/${action.payload.id}/notes`,
      options: {
        errorMessage: `Could not fetch notes for ${action.payload.type}: ${action.payload.id}`,
        retryAction: action,
      },
    });
    yield put(fetchNotesSuccess(results));
  } catch (err) {
    yield put(fetchNotesFailure(err));
  }
}

export function* watchFetchDashboard() {
  yield takeLatest(actionTypes.DASHBOARD_REQUEST, fetchDashboard);
}

function* watchSaveNotes() {
  yield takeLatest(actionTypes.SAVE_NOTES_REQUEST, saveNotes);
}

function* watchFetchNotes() {
  yield takeLatest(actionTypes.FETCH_NOTES_REQUEST, fetchNotes);
}

export default [fork(watchFetchDashboard), fork(watchSaveNotes), fork(watchFetchNotes)];
